export const algoliaConfig = {
  appID: 'R7YU5FB6AE',
  searchOnlyAPIKey: '221e059eb7d6e19c07a95dfc65bf7c39',
  student_index: 'dev_rhodes_students'
}


// WEBPACK FOOTER //
// ./src/core/algolia/config.js